import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence, useAnimate } from "motion/react";

import { useNavigate } from "react-router-dom";
import AppModal from "../components/AppModal.jsx";

import routeCongig from "./routeConfig.json";
import appConfig from "./posts/apps/appConfig.json";
import { style } from "motion/react-client";

const IndexPage = ({ posts, logout, apps }) => {
  const navigate = useNavigate();
  const [scope, animate] = useAnimate();
  const [modalIsOpen, setModalIsOpen] = useState(null);

  const handleAnimate = async (slug) => {
    await animate(document.body, { opacity: 0 });
    navigate(slug);
  };

  const introAnimations = {
    container: {
      initial: {},
      animate: {},
    },
    heading: {
      initial: { opacity: 0, y: -64 },
      animate: { opacity: 1, y: 0 },
    },
    body: {
      initial: { opacity: 0, y: 64 },
      animate: { opacity: 1, y: 0 },
    },
    icons: {
      initial: {},
      animate: {},
      icon: {
        initial: { opacity: 0, x: 148, rotate: "-10deg" },
        animate: (custom) => ({
          opacity: 1,
          x: 0,
          margin: "0 -12px 0 0",
          transition: { delay: custom * 0.1 },
        }),
        whileHover: {
          scale: 1.5,
          zIndex: 40,
          rotate: "0deg",
          // margin: "0 24px 0 24px",
        },
      },
    },

    cards: {
      initial: { opacity: 0, y: 48 },
      animate: { opacity: 1, y: 0 },
    },
  };

  const baseStyles = {
    caseStudy:
      "relative w-full h-[600px] overflow-hidden rounded-md px-12 pt-12",
    app: "relative w-full h-full overflow-hidden rounded-md",
  };

  const CardContent = ({ caseStudy, imgUrl, imageConfig }) => {
    const styles = {
      offset: {
        left: "-left-[25%]",
        right: "-right-[25%]",
      },
    };

    const generateStyleString = (style) => {
      switch (style) {
        case "offset":
          return `absolute object-fit top-0 pt-4 ${
            styles.offset[imageConfig?.offset]
          }`;
        case "contain":
          return `absolute p-4 bottom-0 object-contain w-full h-full`;
        default:
          return `p-2`;
      }
    };
    return (
      <div
        style={{ backgroundColor: routeCongig[caseStudy].theme.accent }}
        className="h-full flex flex-col"
      >
        <div className="px-8 pt-8">
          <h2
            style={{ color: routeCongig[caseStudy].theme.heading }}
            className="font-bold font-serif text-xl"
          >
            {routeCongig[caseStudy].title}
          </h2>
          <p
            style={{ color: routeCongig[caseStudy].theme.heading }}
            className="mb-4"
          >
            {routeCongig[caseStudy].subtitle}
          </p>
          <button
            className="font-serif font-bold bg-white/50 text-black px-2 py-1 rounded-md"
            onClick={() => {
              navigate(routeCongig[caseStudy].slug);
            }}
          >
            {`Read case study \>`}
          </button>
        </div>
        <div className="grow overflow-hidden flex items-start">
          <div className="relative w-full h-full">
            <img
              className={generateStyleString(imageConfig.style)}
              src={imageConfig.url}
              alt=""
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <motion.div
      // ref={scope}
      // initial="initial"
      // animate="animate"
      // variants={introAnimations.container}
      className={`flex flex-col items-center px-6`}
    >
      <div className="flex w-full max-w-screen-xl">
        <div className="max-w-3xl px-6 md:px-0 pt-32 pb-12 mb-12 lg:pl-12">
          <div className="mb-16">
            <motion.h1
              onClick={() => logout()}
              variants={introAnimations.heading}
              className="mb-4 text-[40px] font-bold font-serif"
            >
              Hi, I'm Nick
            </motion.h1>
            <motion.p
              variants={introAnimations.heading}
              className="text-2xl font-light mb-12"
            >
              I help companies solve problems by defining and designing
              exceptional experiences for their users.
            </motion.p>
            <motion.div
              variants={introAnimations.heading}
              className="h-1 w-16 bg-dividers"
            ></motion.div>
          </div>
          <motion.div
            variants={introAnimations.body}
            className="font-sans font-light text-lg"
          >
            <p className="mb-4">
              I’ve worked with a range of organisations in healthcare, banking,
              SAAS, and energy.
            </p>
            <p className="mb-4">
              I’m currently a Senior Experience Designer at{" "}
              <Link
                reloadDocument
                to="https://reckitt.com/"
                className=" font-bold text-link underline focus:bg-link focus:text-body focus:no-underline"
              >
                Reckitt
              </Link>{" "}
              leading design for some of the worlds best known health, hygiene,
              and nutrition brands.
            </p>
            {/* <img src={require("./companies.png")} alt="" className="mb-12" /> */}
            <p className="mb-4">
              I’ve written about{" "}
              <Link
                reloadDocument
                to="https://www.linkedin.com/pulse/starting-your-first-accessibility-audit-nick-harris-euy8e"
                className=" font-bold text-link underline focus:bg-link focus:text-body
           focus:no-underline"
              >
                {" "}
                how to get started with accessibility
              </Link>
              {", "}
              and I love developing my own apps.
            </p>
            <p className="">
              Say hello on{" "}
              <Link
                reloadDocument
                to="https://www.linkedin.com/in/nick-harris-aa753125"
                className=" font-bold text-link underline focus:bg-link focus:text-body
           focus:no-underline"
              >
                {" "}
                LinkedIn
              </Link>{" "}
              or read some of my case studies below.
            </p>
          </motion.div>
        </div>
      </div>
      <div className="max-w-screen-xl w-full mb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 auto-rows-[250px] grid-flow-row gap-6">
          <div className="md:rounded-tl-[50px] rounded-lg overflow-hidden row-span-2 lg:col-span-4">
            <CardContent
              caseStudy={"ctc"}
              imageConfig={{
                url: require("./ctc_cover.png"),
                style: "offset",
                position: "",
                offset: "right",
              }}
            />
          </div>
          <div className="md:rounded-tr-[50px] rounded-lg overflow-hidden row-span-2 lg:col-span-2">
            <CardContent
              caseStudy={"cmb"}
              imageConfig={{
                url: require("./cmb_cover.png"),
                style: "contain",
                position: "",
                offset: "right",
              }}
            />
          </div>
          <div className="col-span-1 lg:col-span-2 row-span-2 md:row-start-3 md:row-end-5 grid grid-rows-subgrid gap-6">
            <button
              className="bg-[#2A2937] rounded-lg overflow-hidden col-span-2 row-span-1 flex relative"
              onClick={() => {
                setModalIsOpen({ ...appConfig["Typify"] });
              }}
            >
              <div className="h-full text-left p-6">
                <h2 className="text-[#4AFF5C] text-xl font-serif">
                  Typify browser plugin
                </h2>
                <p className="text-white">Design and development.</p>
                <p className="text-white">
                  Analyse the typography of any webpage! Available now on
                  Firefox and Chrome
                </p>
              </div>
              <div className="w-1/3 flex items-end">
                <img className="" src={require("./typify_cover.png")} alt="" />
              </div>
            </button>
            <button
              className="bg-[#4F46E5] rounded-lg overflow-hidden col-span-2 row-span-1 relative flex text-left"
              onClick={() => {
                setModalIsOpen({ ...appConfig["Rota"] });
              }}
            >
              <div className="w-1/2 h-full md:w-full relative grow flex justify-center items-center overflow-hidden">
                <img
                  className="absolute scale-150 -left-[30%]"
                  src={require("./rota_cover.png")}
                  alt=""
                />
              </div>
              <div className="h-full md:h-auto w-1/2 md:w-full bg-black/25 text-white p-6">
                <h2 className="font-bold font-serif text-xl">ROTA</h2>
                <p>Design and development of bespoke scheduling software.</p>
              </div>
            </button>
          </div>
          <div className="rounded-lg overflow-hidden md:col-span-1 lg:col-span-4 row-span-2">
            <CardContent
              caseStudy={"cx"}
              imageConfig={{
                url: require("./cx_cover.png"),
                style: "offset",
                position: "",
                offset: "right",
              }}
            />
          </div>
          <div className="rounded-lg overflow-hidden lg:col-span-4 row-span-2 lg:col-start-1">
            <CardContent
              caseStudy={"t2a"}
              imageConfig={{
                url: require("./t2a_cover.png"),
                style: "offset",
                offset: "left",
              }}
            />
          </div>

          <div className="rounded-lg overflow-hidden row-span-2 lg:col-span-2">
            <CardContent
              caseStudy={"extramed"}
              imageConfig={{
                url: require("./posts/caseStudies/extramed/media/cover.png"),
                style: "contain",
              }}
            />
          </div>

          <button
            className="bg-slate-100 lg:rounded-bl-[50px] rounded-lg overflow-hidden col-span-1 lg:col-span-3 flex text-left"
            onClick={() => {
              setModalIsOpen({ ...appConfig["PriorityONE"] });
            }}
          >
            <div className="w-1/2 h-full md:w-full relative grow flex justify-center items-center overflow-hidden">
              <img
                className="absolute"
                src={require("./priorityONE_cover.png")}
                alt=""
              />
            </div>
            <div className="h-full md:h-auto w-1/2 md:w-full text-black p-6">
              <h2 className="font-bold font-serif text-xl">PriorityONE</h2>
              <p>Design and development of my own prioritisation software.</p>
            </div>
          </button>
          <button
            className="bg-[#F3CE49] lg:rounded-br-[50px] rounded-lg overflow-hidden col-span-1 lg:col-span-3 flex text-left"
            onClick={() => {
              setModalIsOpen({ ...appConfig["Lemon"] });
            }}
          >
            <div className="w-1/2 h-full md:w-full relative grow flex justify-center items-center overflow-hidden">
              <img
                className="absolute"
                src={require("./lemon_cover.png")}
                alt=""
              />
            </div>
            <div className="h-full md:h-auto w-1/2 md:w-full text-black p-6">
              <h2 className="font-bold font-serif text-xl">Lemon</h2>
              <p>Used car buying guide. Design and development.</p>
            </div>
          </button>
        </div>
      </div>
      <AnimatePresence>
        {modalIsOpen && (
          <AppModal onClose={setModalIsOpen} content={{ ...modalIsOpen }} />
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default IndexPage;
